export default __webpack_public_path__ + "static/media/zkatana-logo.d6d9b4b5.png";